import React from 'react';
import * as styles from './Hero.module.scss';
const BREAKPOINT_SOURCES = [{
  key: '1920',
  media: '(min-width: 1920px)'
}, {
  key: '1440',
  media: '(min-width: 1440px)'
}, {
  key: '810',
  media: '(min-width: 810px)'
}];
const FALLBACK_KEYS = ['fallback', 'fallbak', 'default'];
const Stars = () => /*#__PURE__*/React.createElement("span", {
  className: styles.rootRatingStars,
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "71",
  height: "13",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8766A",
  d: "M5.814 1.05c.154-.312.231-.468.336-.518a.334.334 0 0 1 .287 0c.105.05.181.206.335.518l1.46 2.958a.73.73 0 0 0 .102.174c.03.031.064.057.104.075.044.02.095.028.196.043l3.266.477c.344.05.516.076.595.16.07.073.102.173.089.273-.015.115-.14.236-.389.478L9.833 7.99c-.074.072-.11.108-.134.15a.334.334 0 0 0-.04.123c-.006.048.003.099.02.2l.558 3.25c.058.343.088.514.033.616a.334.334 0 0 1-.233.169c-.114.02-.268-.06-.575-.222l-2.92-1.535a.73.73 0 0 0-.184-.082.33.33 0 0 0-.129 0c-.048.01-.093.034-.184.082l-2.92 1.535c-.308.162-.462.243-.575.222a.334.334 0 0 1-.233-.17c-.055-.1-.026-.272.033-.615l.558-3.25a.73.73 0 0 0 .02-.2.334.334 0 0 0-.04-.123c-.024-.042-.06-.078-.134-.15L.39 5.69c-.248-.243-.373-.364-.388-.48-.013-.099.02-.2.088-.272.08-.084.252-.11.596-.16L3.953 4.3c.101-.015.152-.022.196-.043a.334.334 0 0 0 .104-.075c.033-.036.056-.082.101-.174l1.46-2.958ZM20.401 1.05c.154-.312.23-.468.335-.518a.334.334 0 0 1 .288 0c.104.05.181.206.335.518l1.46 2.958c.046.092.068.138.101.174.03.031.065.057.104.075.044.02.095.028.197.043l3.265.477c.344.05.516.076.596.16.07.073.102.173.089.273-.016.115-.14.236-.389.478L24.42 7.99c-.074.072-.11.108-.135.15a.335.335 0 0 0-.04.123c-.005.048.004.099.02.2l.558 3.25c.06.343.088.514.033.616a.334.334 0 0 1-.232.169c-.114.02-.268-.06-.576-.222l-2.92-1.535c-.09-.048-.136-.072-.184-.082a.33.33 0 0 0-.128 0c-.048.01-.094.034-.185.082l-2.92 1.535c-.307.162-.46.243-.575.222a.334.334 0 0 1-.232-.17c-.055-.1-.026-.272.033-.615l.557-3.25a.733.733 0 0 0 .02-.2.333.333 0 0 0-.04-.123.726.726 0 0 0-.134-.15l-2.362-2.3c-.249-.243-.373-.364-.389-.48-.013-.099.02-.2.09-.272.079-.084.25-.11.595-.16l3.265-.477c.102-.015.153-.022.197-.043a.332.332 0 0 0 .104-.075.729.729 0 0 0 .101-.174l1.46-2.958ZM34.988 1.05c.154-.312.23-.468.335-.518a.334.334 0 0 1 .288 0c.104.05.181.206.335.518l1.46 2.958c.045.092.068.138.101.174.03.031.065.057.104.075.044.02.095.028.197.043l3.265.477c.344.05.516.076.596.16.07.073.102.173.089.273-.016.115-.14.236-.39.478L39.008 7.99c-.074.072-.11.108-.135.15a.334.334 0 0 0-.04.123c-.005.048.004.099.02.2l.558 3.25c.059.343.088.514.033.616a.334.334 0 0 1-.232.169c-.114.02-.268-.06-.576-.222l-2.92-1.535a.732.732 0 0 0-.184-.082.33.33 0 0 0-.128 0 .73.73 0 0 0-.185.082l-2.92 1.535c-.307.162-.46.243-.575.222a.334.334 0 0 1-.232-.17c-.055-.1-.026-.272.033-.615l.557-3.25a.729.729 0 0 0 .02-.2.333.333 0 0 0-.04-.123.726.726 0 0 0-.134-.15l-2.362-2.3c-.249-.243-.373-.364-.389-.48-.013-.099.02-.2.09-.272.079-.084.25-.11.595-.16l3.265-.477a.731.731 0 0 0 .197-.043.335.335 0 0 0 .104-.075c.033-.036.056-.082.101-.174l1.46-2.958ZM49.575 1.05c.154-.312.23-.468.335-.518a.334.334 0 0 1 .287 0c.105.05.182.206.336.518l1.46 2.958a.733.733 0 0 0 .1.174c.03.031.066.057.105.075.044.02.095.028.196.043l3.266.477c.344.05.516.076.596.16.069.073.101.173.088.273-.015.115-.14.236-.389.478L53.593 7.99a.726.726 0 0 0-.134.15.333.333 0 0 0-.04.123c-.005.048.003.099.02.2l.558 3.25c.059.343.088.514.033.616a.334.334 0 0 1-.233.169c-.113.02-.267-.06-.575-.222l-2.92-1.535a.732.732 0 0 0-.184-.082.33.33 0 0 0-.129 0c-.047.01-.093.034-.184.082l-2.92 1.535c-.307.162-.461.243-.575.222a.334.334 0 0 1-.233-.17c-.055-.1-.025-.272.033-.615l.558-3.25c.017-.101.026-.152.02-.2a.335.335 0 0 0-.04-.123c-.024-.042-.06-.078-.134-.15l-2.362-2.3c-.25-.243-.374-.364-.389-.48-.013-.099.02-.2.089-.272.08-.084.251-.11.595-.16l3.266-.477c.102-.015.152-.022.197-.043a.334.334 0 0 0 .103-.075c.034-.036.056-.082.102-.174l1.46-2.958ZM64.162 1.05c.153-.312.23-.468.335-.518a.334.334 0 0 1 .287 0c.105.05.182.206.335.518l1.46 2.958a.729.729 0 0 0 .102.174c.03.031.065.057.104.075.044.02.095.028.196.043l3.266.477c.344.05.516.076.595.16.07.073.102.173.09.273-.016.115-.14.236-.39.478L68.18 7.99c-.073.072-.11.108-.134.15a.333.333 0 0 0-.04.123c-.006.048.003.099.02.2l.558 3.25c.059.343.088.514.033.616a.334.334 0 0 1-.233.169c-.114.02-.267-.06-.575-.222l-2.92-1.535c-.09-.048-.136-.072-.184-.082a.33.33 0 0 0-.129 0 .732.732 0 0 0-.184.082l-2.92 1.535c-.307.162-.461.243-.575.222a.334.334 0 0 1-.233-.17c-.055-.1-.026-.272.033-.615l.558-3.25a.733.733 0 0 0 .02-.2.333.333 0 0 0-.04-.123.726.726 0 0 0-.134-.15l-2.362-2.3c-.25-.243-.374-.364-.389-.48-.013-.099.02-.2.089-.272.08-.084.251-.11.595-.16L62.3 4.3c.101-.015.152-.022.196-.043a.332.332 0 0 0 .104-.075.729.729 0 0 0 .102-.174l1.46-2.958Z"
})));
const getSourceByKey = (collection, key) => {
  var _ref, _ref2, _collection$key;
  if (!collection) {
    return null;
  }
  return (_ref = (_ref2 = (_collection$key = collection[key]) !== null && _collection$key !== void 0 ? _collection$key : collection[Number(key)]) !== null && _ref2 !== void 0 ? _ref2 : collection[`${key}px`]) !== null && _ref !== void 0 ? _ref : null;
};
const getFallbackSource = collection => {
  if (!collection) {
    return null;
  }
  for (const fallbackKey of FALLBACK_KEYS) {
    if (collection[fallbackKey]) {
      return collection[fallbackKey];
    }
  }
  return null;
};
const getMimeType = src => {
  var _src$split$0$split$po;
  if (!src) {
    return undefined;
  }
  const extension = (_src$split$0$split$po = src.split('?')[0].split('.').pop()) === null || _src$split$0$split$po === void 0 ? void 0 : _src$split$0$split$po.toLowerCase();
  switch (extension) {
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'webp':
      return 'image/webp';
    case 'avif':
      return 'image/avif';
    case 'gif':
      return 'image/gif';
    default:
      return undefined;
  }
};
const Hero = ({
  rating,
  heading,
  subheading,
  description,
  button,
  buttonSecondary,
  image,
  picture
}) => {
  const heroAlt = (picture === null || picture === void 0 ? void 0 : picture.alt) || (image === null || image === void 0 ? void 0 : image.alt) || 'Piękno zaczyna się od zdrowia';
  const ratingValue = rating === null || rating === void 0 ? void 0 : rating.value;
  const hasRatingValue = ratingValue !== undefined && ratingValue !== null && `${ratingValue}`.trim() !== '';
  const formattedRatingValue = typeof ratingValue === 'number' ? typeof ratingValue.toFixed === 'function' ? ratingValue.toFixed(1) : ratingValue : ratingValue;
  const ratingCount = rating === null || rating === void 0 ? void 0 : rating.count;
  const formattedRatingCount = typeof ratingCount === 'number' ? `${ratingCount.toLocaleString()} zweryfikowanych opinii` : ratingCount;
  const ratingIconType = rating === null || rating === void 0 ? void 0 : rating.icon;
  const renderRatingIcon = () => {
    if (!ratingIconType || ratingIconType === 'svg') {
      return /*#__PURE__*/React.createElement(Stars, null);
    }
    if (/*#__PURE__*/React.isValidElement(ratingIconType)) {
      return ratingIconType;
    }
    if (typeof ratingIconType === 'string') {
      return /*#__PURE__*/React.createElement("img", {
        className: styles.rootRatingStars,
        src: ratingIconType,
        alt: "",
        "aria-hidden": "true"
      });
    }
    return null;
  };
  const copySubheading = subheading !== null && subheading !== void 0 ? subheading : description;
  const renderPicture = () => {
    if (!picture) {
      return null;
    }
    const fallbackSrc = getFallbackSource(picture.default) || getFallbackSource(picture.webp) || getFallbackSource(picture.avif);
    if (!fallbackSrc) {
      return null;
    }
    const sources = [];
    const appendSourcesForFormat = (formatName, explicitType) => {
      const collection = picture[formatName];
      if (!collection) {
        return;
      }
      BREAKPOINT_SOURCES.forEach(({
        key,
        media
      }) => {
        const src = getSourceByKey(collection, key);
        if (!src) {
          return;
        }
        sources.push(/*#__PURE__*/React.createElement("source", {
          key: `${formatName}-${key}`,
          media: media,
          srcSet: src,
          type: explicitType !== null && explicitType !== void 0 ? explicitType : getMimeType(src)
        }));
      });
      const collectionFallback = getFallbackSource(collection);
      if (collectionFallback && collectionFallback !== fallbackSrc) {
        sources.push(/*#__PURE__*/React.createElement("source", {
          key: `${formatName}-fallback`,
          srcSet: collectionFallback,
          type: explicitType !== null && explicitType !== void 0 ? explicitType : getMimeType(collectionFallback)
        }));
      }
    };
    appendSourcesForFormat('avif', 'image/avif');
    appendSourcesForFormat('webp', 'image/webp');
    appendSourcesForFormat('default');
    return /*#__PURE__*/React.createElement("picture", {
      className: styles.rootMedia
    }, sources, /*#__PURE__*/React.createElement("img", {
      src: fallbackSrc,
      alt: heroAlt,
      fetchpriority: "high",
      loading: "eager",
      decoding: "async"
    }));
  };
  const pictureElement = renderPicture();
  const shouldRenderImageFallback = !pictureElement && (image === null || image === void 0 ? void 0 : image.src);
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCopy
  }, hasRatingValue && /*#__PURE__*/React.createElement("div", {
    className: styles.rootRating
  }, renderRatingIcon(), /*#__PURE__*/React.createElement("span", {
    className: styles.rootRatingValue
  }, formattedRatingValue), formattedRatingCount && /*#__PURE__*/React.createElement("span", {
    className: styles.rootRatingCount
  }, formattedRatingCount)), heading && /*#__PURE__*/React.createElement("h1", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), copySubheading && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription,
    dangerouslySetInnerHTML: {
      __html: copySubheading
    }
  }), ((button === null || button === void 0 ? void 0 : button.label) || (buttonSecondary === null || buttonSecondary === void 0 ? void 0 : buttonSecondary.label)) && /*#__PURE__*/React.createElement("div", {
    className: styles.rootButtons
  }, (button === null || button === void 0 ? void 0 : button.label) && /*#__PURE__*/React.createElement("a", {
    className: styles.rootButton,
    href: button.href || '#'
  }, button.label), (buttonSecondary === null || buttonSecondary === void 0 ? void 0 : buttonSecondary.label) && /*#__PURE__*/React.createElement("a", {
    className: `${styles.rootButton} ${styles.rootButtonSecondary}`,
    href: buttonSecondary.href || '#'
  }, buttonSecondary.label))), pictureElement, shouldRenderImageFallback && /*#__PURE__*/React.createElement("picture", {
    className: styles.rootMedia
  }, /*#__PURE__*/React.createElement("img", {
    src: image.src,
    alt: heroAlt,
    fetchpriority: "high",
    loading: "eager",
    decoding: "async"
  }))));
};
export default Hero;